<template>
  <table
    :id="randomId"
    :class="
      listView && $vuetify.breakpoint[listView]
        ? 'table_list_view'
        : cardView && $vuetify.breakpoint[cardView]
        ? 'table_card_view'
        : hasActive
        ? 'table_tile_view_active'
        : 'table_tile_view'
    "
  >
    <thead v-if="$vuetify.breakpoint[listView]" :class="{ sticky }">
      <slot name="header">
        <tr>
          <th
            v-for="(item, h) in head"
            :key="h"
            @click="item.sort ? onFilterParams(item.sort.name, item.sort.value) : null"
          >
            <div class="sort_head" :class="item.sort ? 'pointer' : ''">
              <div class="text-pre-line">{{ item.text }}</div>
              <IconSort v-if="item.sort" :param="item.sort.name" />
            </div>
          </th>
        </tr>
      </slot>
    </thead>
    <thead v-else class="sort_block" :class="{ sticky: sticky && $vuetify.breakpoint[listView] }">
      <template v-for="(item, h) in head">
        <th
          v-if="item.sort"
          :key="h"
          @click="item.sort ? onFilterParams(item.sort.name, item.sort.value) : null"
          class="sort_head pointer"
        >
          <div class="text-pre-line">{{ item.text }}</div>
          <IconSort :param="item.sort.name" />
        </th>
      </template>
    </thead>
    <tbody>
      <slot></slot>
    </tbody>
  </table>
</template>

<script>
import IconSort from 'components/icons/IconSort'

export default {
  name: 'BaseTableView',
  components: { IconSort },
  props: {
    head: {
      type: Array,
      default: () => {
        return []
      },
    },
    listView: {
      type: String,
      default: 'xlOnly',
    },
    cardView: {
      type: String,
      default: 'smAndDown',
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'table_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    hasActive() {
      return this.head.map((data) => data.active).includes(true)
    },
  },
  data: () => ({
    tbody: null,
  }),
  mounted() {
    this.setHeaderToBodyRows()
  },
  updated() {
    this.setHeaderToBodyRows()
  },
  methods: {
    setHeaderToBodyRows() {
      const table = document.getElementById(this.randomId)
      if (table) {
        this.tbody = table.getElementsByTagName('tbody')
        for (let tb of this.tbody) {
          if (tb.children.length) {
            for (let [trKey, trItem] of Object.entries(tb.children)) {
              for (let [tdKey, tdItem] of Object.entries(trItem.children)) {
                if (!tdItem.hasAttribute('data-title')) {
                  if (this.head && this.head[tdKey] && this.head[tdKey].text) {
                    tdItem.setAttribute('data-title', this.head[tdKey].text)
                  }
                }
                if (this.head[tdKey] && this.head[tdKey].active) {
                  tdItem.classList.add('base_table_view_active')
                  tdItem.style.gridRowEnd = String(Math.ceil((this.head.length - 1) / 3) + 1)
                }
              }
            }
          }
        }
      }
    },

    onFilterParams(paramName, value) {
      if (paramName && value) {
        this.$routerPushQuerySort(paramName, value)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.btn {
  display: flex;
  height: 100%;
  gap: 28px;
  justify-content: flex-end;
  justify-items: center;
}

.sort {
  &_block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: right;
    column-gap: 32px;
    width: 100%;

    .sort_head {
      font-size: 0.85rem !important;
      font-weight: bold;
      color: #adadad;
      margin-bottom: 8px;
    }
  }

  &_head {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.sorted {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pointer {
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: initial;
  border-spacing: 0;

  &.table {
    &_tile_view {
      & > tbody {
        & > tr {
          display: grid;
          grid-template-rows: auto;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          background: transparent;
          border-top: 1px solid #d1d1d1;
          width: 100%;

          &:hover {
            background: #ffffff;
          }

          td {
            padding: 10px;
            width: 100% !important;
            height: 100%;

            &:before {
              content: attr(data-title);
              display: block;
              top: auto;
              position: static !important;
              height: auto;
              bottom: auto;
              font-size: 0.75rem !important;
              margin-bottom: 8px;
              white-space: pre-line;
              text-align: left;
              font-weight: bold;
              background: none;
              color: #adadad;
            }
          }
        }
      }

      &_active {
        @extend .table_tile_view;

        & > tbody {
          tr {
            display: inline-grid;
            grid-template-columns: 1fr 1fr 1fr minmax(80px, auto);
            grid-auto-rows: auto;
            align-items: center;

            .base_table_view_active {
              grid-column: 4;
              grid-row-start: 1;

              .buttons {
                @extend .btn;
              }
            }
          }
        }
      }
    }

    &_card_view {
      & > tbody {
        tr {
          display: flex;
          flex-wrap: wrap;
          background: #ffffff;
          margin-bottom: 10px;

          td {
            width: 100% !important;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            border-bottom: 1px solid #e6e6e6;

            &:last-child {
              border-bottom: none;
            }

            &:before {
              content: attr(data-title);
              display: block;
              top: auto;
              position: static !important;
              height: auto;
              bottom: auto;
              font-size: 0.85rem !important;
              padding-right: 10px;
              white-space: pre-line;
              text-align: left;
              font-weight: bold;
              background: none;
              color: #adadad;
              margin-right: auto;
            }
          }

          .base_table_view_active {
            justify-content: space-around;
            order: 100;

            &:before {
              margin-right: 0;
            }

            .buttons {
              width: 100%;
              display: flex;
              justify-content: space-around;
            }
          }
        }
      }
    }

    &_list_view {
      & > thead {
        &.sticky {
          position: sticky;
          top: 115px;
        }
        z-index: 2;

        tr {
          display: table-row !important;
          background: #fafafa;
          border: 1px solid #d1d1d1;

          th {
            position: sticky;
            top: 0;
            z-index: 2;
            background-color: #fafafa;
            font-size: 1rem !important;
            font-weight: 500;
            color: #2c2c2c !important;
            padding: 10px;
            height: 64px !important;
            text-align: left;
          }
        }
      }

      & > tbody {
        tr {
          background: #f2f2f2;
          border: 1px solid #d1d1d1;

          &:hover {
            background: #ffffff;
          }
        }
      }

      tr {
        th {
          border-top: 1px solid #d1d1d1;
        }
        th,
        td {
          height: 64px;
          width: auto;
          padding: 8px;
          border-bottom: 1px solid #d1d1d1;
          border-left: none;

          &:first-child {
            padding-left: 25px;
            border-left: 1px solid #d1d1d1;
          }

          &:last-child {
            padding-right: 25px;
            border-right: 1px solid #d1d1d1;
          }

          &.base_table_view_active {
            .buttons {
              @extend .btn;
            }
          }

          &:before {
            display: none !important;
          }
        }
      }
    }
  }
}
</style>
